/**
 * List of error origins
 *
 */
export const ErrorOrigins = {
  CLIENT_SIDE_VALIDATION_ERROR: 'client_validation_error',
  SERVER_SIDE_VALIDATION_ERROR: 'server_validation_error',
  SERVER_SIDE_ERROR: 'server_error'
}
